import ErrorMessages from './ErrorMessages';

interface InputProps {
	autocomplete?: string;
	disabled?: boolean;
	errorMessages?: string[];
	isValid?: boolean | null;
	label?: string;
	name: string;
	onChange: (value: string) => void;
	required?: boolean;
	type: string;
	value: string;
	placeholder?: string;
}

export function TextInput(props: InputProps) {
	props.type = 'text';
	return <Input {...props} />;
}

export default function Input({
	autocomplete = 'on',
	disabled = false,
	errorMessages = [],
	isValid = null,
	label = '',
	name,
	onChange,
	required = false,
	type,
	value,
	placeholder = '',
}: InputProps) {
	const inputAttributes = {
		id: name,
		disabled,
		name,
		onChange: (e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value),
		required,
		type,
		value,
		autoComplete: autocomplete,
	};

	const formFieldClasses = ['form-field'];
	if (isValid !== null) {
		formFieldClasses.push(isValid ? 'form-field--valid' : 'form-field--error');
	}

	return (
		<div className="form-field-wrapper">
			<div className={formFieldClasses.join(' ')} data-field-type={type} data-field-name={name}>
				{label && <label htmlFor={name}>{label}</label>}
				<input {...inputAttributes} placeholder={placeholder} />
			</div>

			<ErrorMessages messages={errorMessages} />
		</div>
	);
}
